'use client';

import PatternBackground from 'components/ui/PatternBackground';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import heritageField from '../../images/marketing/heritage-field.webp';


export default function HeritageSection() {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"]
  });

  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section ref={containerRef} className="relative min-h-[55vh] sm:min-h-[70vh] md:min-h-[80vh] flex items-center overflow-hidden bg-singaraa-dark py-14 sm:py-18 md:py-24">
      {/* Background Parallax Image */}
      <motion.div
        style={{ y }}
        className="absolute inset-0 z-0 opacity-40"
      >
        <img
          src={heritageField}
          alt="Indian Peanut Fields"
          className="w-full h-full object-cover"
        />
      </motion.div>

      {/* Texture / Pattern Overlay */}
      <div className="absolute inset-0 z-1 bg-gradient-to-t from-singaraa-dark via-singaraa-dark/70 to-singaraa-dark/40 pointer-events-none" />
      <div className="absolute inset-0 z-2 pointer-events-none">
        <PatternBackground className="opacity-10" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-20 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="inline-block uppercase tracking-[0.2em] sm:tracking-[0.25em] text-singaraa-gold font-semibold text-[11px] sm:text-xs md:text-sm mb-3 sm:mb-4"
          >
            OUR ROOTS & HERITAGE
          </motion.span>

          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="font-heading text-2xl sm:text-3xl md:text-5xl lg:text-6xl text-white mb-4 sm:mb-6 leading-tight drop-shadow-md"
          >
            Rooted in India.<br />
            <span className="text-singaraa-gold italic">Made for Modern Snacking.</span>
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="font-body text-sm sm:text-base md:text-lg lg:text-xl text-singaraa-cream/90 leading-relaxed max-w-2xl mx-auto drop-shadow-sm px-2 sm:px-0"
          >
            Singaraa connects the simplicity of Indian ingredients with a contemporary snacking experience.
            We honor the traditions of the Kathiyawadi heartland while delivering a premium product suited for today's lifestyle.
          </motion.p>
        </div>
      </div>
    </section>
  );
}
